import NetworkService from "./NetworkService"

export default class SessionService {
    updateSession = (params: any) => {

    }
}